<div class="emoji_main">
    <div class="emoji_context">
        <ng-container [ngSwitch]="selectIndex">
            <ng-container *ngSwitchCase="0">
                <div class="emoji_picker_main">
                    <span *ngFor="let item of emojiMapList"  (click)="selectEmoji(item,$event)"><img src="/assets/img/emoji/{{item.value}}"
                            title="{{item.key}}" /></span>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="1"></ng-container>
        </ng-container>
    </div>
    <div class="emoji_footer">
        <div class="emoji_item" [ngClass]="{'item_select':selectIndex==0}" (click)="selectItem(0)"><i nz-icon
                nzType="smile" nzTheme="outline"></i></div>
        <div class="emoji_item" [ngClass]="{'item_select':selectIndex==1}" (click)="selectItem(1)"><i nz-icon
                [nzType]="'heart'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#eb2f96'"></i>
        </div>
    </div>
</div>